export enum Role {
  API = 'api',
  REVIEW = 'review',
  EXTERNAL_REVIEW = 'external-review',
  NUTRITION = 'nutrition',
  ZONE = 'zone',
  PT = 'pt',
  SPORT_SCIENCE = 'sport-science',
  BODY_ANALYSIS_DEVICE = 'body-analysis-device',
  TEAM_CHALLENGES = 'team-challenges',
  BUSINESS_TOOLS = 'business-tools',
  PT_VOICE_RECORDER = 'pt-voice-recorder',
}
